// extracted by mini-css-extract-plugin
module.exports = {"inline-icon":"_3UezigcQsc1E94W-rGh7pr"};